import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import PublicShell from '../components/PublicShell';
import { CONTACTS } from '../config/brand';

const H2 = ({ children }) => <h2 className="text-lg md:text-xl font-bold text-white pt-4" style={{ fontFamily: "'Outfit', sans-serif" }}>{children}</h2>;
const arr = (v) => (Array.isArray(v) ? v : []);

export function AboutUs() {
    const { t } = useTranslation();
    return (
        <PublicShell eyebrow={t('legal.about.eyebrow')} title={t('legal.about.title')} testId="about-page">
            <div className="flex flex-col sm:flex-row gap-6 items-start mb-2" data-testid="about-founder">
                <img src="/about/nikayo.jpg" alt="Nikayo — founder and educator" className="w-44 h-56 rounded-2xl object-cover object-top border border-[#FFB800]/40 shadow-[0_0_40px_rgba(255,184,0,0.15)] shrink-0" data-testid="about-founder-photo" />
                <div>
                    <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#FFB800] mb-1">{t('legal.about.role')}</p>
                    <p className="text-2xl font-black text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Nikayo</p>
                    <p className="text-sm text-zinc-400 mt-1">{t('legal.about.roleSub')}</p>
                </div>
            </div>
            <p><Trans i18nKey="legal.about.intro" components={{ 1: <strong className="text-white" /> }} /></p>
            <H2>{t('legal.about.whatTitle')}</H2>
            <p>{t('legal.about.what')}</p>
            <H2>{t('legal.about.notTitle')}</H2>
            <ul className="list-disc ps-6 space-y-2">{arr(t('legal.about.not', { returnObjects: true })).map((x) => <li key={x}>{x}</li>)}</ul>
            <H2>{t('legal.about.whoTitle')}</H2>
            <p>{t('legal.about.who')}</p>
            <H2>{t('legal.about.valuesTitle')}</H2>
            <p>{t('legal.about.values')}</p>
            <p className="pt-4 flex flex-wrap gap-4 text-sm">
                <Link to="/learn" className="text-[#FFB800] font-bold underline underline-offset-4" data-testid="about-learn-link">{t('legal.about.learnLink')}</Link>
                <a href={CONTACTS.telegram.url} target="_blank" rel="noopener noreferrer" className="text-zinc-400 underline underline-offset-4">Telegram {CONTACTS.telegram.handle}</a>
            </p>
        </PublicShell>
    );
}

export function ContactUs() {
    const { t } = useTranslation();
    const rows = [
        [t('legal.contact.email'), 'nikayo.fx@gmail.com', 'mailto:nikayo.fx@gmail.com', 'contact-email'],
        [t('legal.contact.whatsapp'), CONTACTS.whatsapp.number, CONTACTS.whatsapp.url, 'contact-whatsapp'],
        [t('legal.contact.telegram'), CONTACTS.telegram.handle, CONTACTS.telegram.url, 'contact-telegram'],
        [t('legal.contact.website'), 'nikayofxguide.com', 'https://nikayofxguide.com', 'contact-site'],
    ];
    return (
        <PublicShell eyebrow={t('legal.contact.eyebrow')} title={t('legal.contact.title')} testId="contact-page">
            <p>{t('legal.contact.intro')}</p>
            <div className="grid sm:grid-cols-2 gap-4 pt-4">
                {rows.map(([label, value, href, tid]) => (
                    <a key={tid} href={href} target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-zinc-800 bg-zinc-950 p-5 hover:border-[#FFB800]/60 transition-colors" data-testid={tid}>
                        <p className="text-[11px] uppercase tracking-widest text-zinc-500 mb-1">{label}</p>
                        <p className="font-bold text-white break-all ltr-only">{value}</p>
                    </a>
                ))}
            </div>
            <H2>{t('legal.contact.addressTitle')}</H2>
            <p data-testid="contact-address">{t('legal.contact.addressLine1')}<br />{t('legal.contact.addressLine2')}<br />{t('legal.contact.addressLine3')}</p>
            <H2>{t('legal.contact.policyTitle')}</H2>
            <p>{t('legal.contact.policy')}</p>
        </PublicShell>
    );
}

export function DisclaimerPage() {
    const { t, i18n } = useTranslation();
    return (
        <PublicShell eyebrow={t('legal.disclaimer.eyebrow')} title={t('legal.disclaimer.title')} testId="disclaimer-page">
            {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <p key={n}><strong className="text-white">{t(`legal.disclaimer.p${n}h`)}</strong> {t(`legal.disclaimer.p${n}`)}</p>
            ))}
            <p className="text-sm text-zinc-500 pt-4">{t('legal.disclaimer.updated')} {new Date().toLocaleDateString(i18n.language === 'ar' ? 'ar-JO' : i18n.language, { month: 'long', year: 'numeric' })}</p>
        </PublicShell>
    );
}
